import { PropsWithChildren, useEffect } from 'react';

import { usePaymentsStore } from '@stores/payment-store';
import { useAuthStore } from '@stores/auth-store';

const BasicConfigProvider = ({ children }: PropsWithChildren) => {
    const { accessToken, oauthToken } = useAuthStore();
    const { fetchCurrencies, fetchCurrencyExchanges } = usePaymentsStore();

    useEffect(() => {
        accessToken && fetchCurrencies();
    }, [accessToken]);

    useEffect(() => {
        oauthToken && fetchCurrencyExchanges(oauthToken);
    }, [oauthToken]);

    return <>{children}</>;
};

export { BasicConfigProvider };
